import { useEqlQuery, useTranslations } from "hooks";
import { SelectCountryLanguageQuery } from "queries/SelectCountryLanguageQuery";
import { useMemo, useState } from "react";
import { MapResponseFn } from "@eco/client";
import { LangPropType } from "../SelectCountry";
import { useEffect } from "react";

/**
 * Use to fetch language from backend
 */
export const useGetCountryLanguage = (): UseGetCountryLanguage => {

    const query = useMemo(() => new SelectCountryLanguageQuery(), [])
    const { data } = useEqlQuery(query, mapCountryLangProp);
    const [countryList, setCountryList] = useState<Array<CountryPropType>>()

    const countriesList = useMemo(() => {
        return data?.map(item => ( `countries_${item.code}`))
    }, [data])

    const languageList = useMemo(() => {
        return data?.map(dataItem => dataItem.languageList.map(item => (`language_${item}`.toLocaleLowerCase())))
    }, [data])

    const countriesListTranslated = useTranslations(countriesList || []);
    
    useEffect(() => {
        if(!countryList && languageList  && countriesListTranslated.length > 0) {
            const countries = data?.map<CountryPropType>((item, index) => 
            ({...item, name: countriesListTranslated[index], languageList: languageList[index] }));
            countries && setCountryList(countries)
        }
    }, [countriesListTranslated, languageList, data, countryList])

    return countryList
}

type UseGetCountryLanguage = Array<CountryPropType> | undefined

export const mapCountryLangProp: MapResponseFn<Array<CountryPropType>, CountryLangPrefetchResponse> = (res: CountryLangPrefetchResponse) => {
    return res.data.map((item) => ({
        name: item.deLi,
        code: item.deKe,
        languageList: item.deChar1.split(','),
        regulatoryRef: getRegulatoryRef(item.deChar2),
    })) as Array<CountryPropType>
}

export const getRegulatoryRef = (reg?: string | null) => {
    if (!reg || ['GHS01', 'GHS02', 'GHS03'].includes(reg)) return 'GHS04'
    if (reg === 'EU') return 'CLP14'
    return reg
}

export type CountryLangPropType = { 
    country?: CountryPropType,
    language?: LangPropType
}

export type CountryPropType  = {
    name: string,
    code: string,
    regulatoryRef: string,
    languageList: Array<string>
}

export type CountryLangPrefetchResponse = {
    data: Array<{
        deId: number,
        deKe: string,
        deLi: string,
        deChar1: string,
        deChar2: string
    }>
    total_count?: number
}
